import { FC, useState } from 'react';
import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { Button } from 'components/Button';

import { PlusIcon } from 'components/icons/PlusIcon';
import { ArrowRightIcon } from 'components/icons/ArrowRightIcon';
import { AddMemberModal } from '../AddMemberModal';

export interface Step8Props {
  nextStep: () => void;
}
export const Step8: FC<Step8Props> = ({ nextStep }) => {
  const [open, setOpen] = useState(false);

  const handleModalClose = () => {
    setOpen(false);
  };
  const handleModalOpen = () => {
    setOpen(true);
  };

  return (
    <Box className="flex flex-col items-center justify-center">
      <AddMemberModal
        open={open}
        onClose={handleModalClose}
        nextStep={nextStep}
      />
      <Typography
        variant="pSemiBold"
        className="mt-8 max-w-[44rem] text-center text-[28px] md:text-[32px]"
      >
        You can also connect people to the workspace
      </Typography>
      <Box className="mt-8 flex items-center gap-4">
        <Button variantType="outlined" onClick={handleModalOpen}>
          <PlusIcon className="mr-2 h-6 w-6" />
          <Typography>Add people</Typography>
        </Button>
        <Button variantType="outlined" onClick={nextStep}>
          <Typography>Skip</Typography>
          <ArrowRightIcon className="ml-2 h-6 w-6" />
        </Button>
      </Box>
    </Box>
  );
};
